{
    "actions": {
        "row": {
            "update_label": "Modifier la SIM",
            "historics_access": "Historique de la SIM",
            "update_plan": "Modifier le forfait",
            "activate": "Activer",
            "terminate": "Résilier",
            "reactivate": "Réactiver",
            "suspend": "Suspendre",
            "replace": "Remplacer la sim",
            "order_sim": "Commander des SIM",
            "add_to": {
                "title": "Ajouter",
                "organization": "Ajouter à l'organisation",
                "client": "Ajouter au client"
            },
            "activate_sim_cards": {
                "title": "Activation multiple",
                "organization": "Mes cartes SIM",
                "client": "Cartes SIM de mes clients"
            },
            "assign": "Affecter",
            "manage_assign": {
                "title": "Gérer l'affectation",
                "reassign": "Réaffecter",
                "unassign": "Désaffecter"
            }
        }
    },
    "filter": {
        "placeholder": {
            "legal_name": "Filtrer par nom de l'organisation",
            "label": "Filtrer par libellé",
            "iccid": "Filtrer par numéro de SIM",
            "units": "Unités"
        },
        "label": {
            "quantity": "Forfait",
            "plan": "Type de forfait"
        },
        "plan_types": {
            "ALL": "Tous",
            "Data Only": "Data Only",
            "WITHOUT_DATA_ONLY": "Sans Data Only"
        },
        "badge": {
            "label": "Forfait",
            "value": "{{value0}} $t(simCard:units.{{value1}}) $t(simCard:filter.plan_types.{{value2}})"
        }
    },
    "form": {
        "error": {
            "required": "Le libellé est requis",
            "max_length": "La longueur maximale (100) du libellé est dépassée"
        }
    },
    "keys": {
        "status": "Statut",
        "legal_name": "Nom de l'organisation",
        "label": "Libellé",
        "iccid": "Numéro de SIM",
        "data": "Forfait",
        "data_usage": "Consommation par mois",
        "created_at": "Ajoutée le",
        "updated_at": "Dernière MAJ",
        "cancellation_date": "Résiliée le",
        "activation_date": "Activation",
        "activation_request_date": "Demande d'activation",
        "cancellation_request_date": "Demande de résiliation",
        "first_comm_date": "Dernière co.",
        "last_comm_date": "Première co.",
        "end_engagement_date": "Fin engagement",
        "dispatch_date": "Envoyée le",
        "suspension_date": "Suspendue le",
        "apns": "APN",
        "mno_name": "Opérateur"
    },
    "modal": {
        "update_label": {
            "title": "Modifier le libellé de la SIM",
            "text": "Libellé",
            "success": "Carte SIM mise à jour avec succès !",
            "error": "Une erreur est survenue lors de la modification de cette SIM"
        },
        "update_plan": {
            "title": "Modifier le forfait de la SIM",
            "steps": {
                "plan_selection": "Étape {{step}} sur {{maxStep}} : Sélection du nouveau forfait",
                "confirmation": "Étape {{step}} sur {{maxStep}} : Confirmation"
            },
            "plan_selection": {
                "text_1": "Il est possible de faire évoluer à la hausse vos forfaits SIM à un forfait supérieur.",
                "text_2": "Néanmoins, la réduction du forfait n'est pas autorisée pour des raisons contractuelles.",
                "text_3": "Si vous choisissez de passer à un forfait supérieur, l'effet rétroactif sera appliqué au 1er jour du mois de souscription.",
                "select": "Forfait :"
            },
            "confirmation": {
                "title": "Update confirmation",
                "text_1": "Êtes-vous sûr de vouloir modifier l'offre de cette SIM sur le forfait \"{{simCardPlan}}\" pour l'organisation {{organizationName}} ?",
                "text_2": "Pour information, le délai généralement constaté est d'environ 1h, mais il peut aller jusqu'à 2 jours.",
                "text_3": "Veuillez donc à anticiper vos demandes de modifications."
            },
            "fetch_plans_error": "Une erreur est survenue lors de la récupération des forfaits SIM",
            "highest_plan_alert": "Vous disposez déjà du forfait le plus élevé, vous ne pourrez donc pas modifier ce champ.",
            "success": "Forfait mis à jour avec succès !",
            "error": "Une erreur est survenue lors de la mise à jour du forfait SIM"
        },
        "activate": {
            "title": "Activation de la carte SIM",
            "steps": {
                "offer_selection": "Étape {{step}} sur {{maxStep}} : Sélection de l'offre",
                "confirmation": "Étape {{step}} sur {{maxStep}} : Confirmation d'activation"
            },
            "selection": {
                "label": "Forfait :",
                "placeholder": "Selectionner une offre"
            },
            "confirmation": {
                "text_1": "Êtes-vous sûr de vouloir activer cette carte SIM avec le forfait {{offer}} ?",
                "text_2": "Pour information, le délai généralement constaté est d'environ 1h, mais il peut aller jusqu'à 2 jours.",
                "text_3": "Veillez donc à anticiper vos demandes d'activations."
            },
            "success": "Carte SIM activée avec succès !",
            "error": "Une erreur est survenue lors de l'activation de cette SIM"
        },
        "terminate": {
            "title": "Confirmation de résiliation",
            "text": "Veuillez confirmer votre demande de résiliation pour cette SIM",
            "success": "Carte SIM résiliée avec succès !",
            "error": "Une erreur est survenue lors de la résiliation de cette SIM"
        },
        "suspend": {
            "title": "Confirmation de suspension",
            "text": "Veuillez confirmer votre demande de suspension pour cette SIM",
            "success": "Carte SIM suspendue avec succès !",
            "error": "Une erreur est survenue lors de la suspension de cette SIM"
        },
        "reactivate": {
            "title": "Confirmation de réactivation",
            "text": "Veuillez confirmer votre demande de réactivation pour cette SIM",
            "success": "Carte SIM réactivée avec succès !",
            "error": "Une erreur est survenue lors de la réactivation de cette SIM"
        },
        "replace": {
            "title": "Remplacement carte SIM",
            "steps": {
                "sim_selection": "Étape {{step}} sur {{maxStep}} : Sélection de la nouvelle SIM",
                "confirmation": "Étape {{step}} sur {{maxStep}} : Confirmation"
            },
            "replacement": "La carte SIM {{previousSim}} sera remplacée par la carte SIM {{nextSim}}.",
            "text_1": "Le remplacement de cette carte SIM ne vous réengagera pas pour 12 mois supplémentaires.",
            "text_2": "Vous continuerez de conserver le même forfait ainsi que le même numéro de téléphone rattaché à l'ancienne carte SIM après l'activation de la nouvelle carte SIM.",
            "success": "Carte SIM remplacée avec succès !",
            "error": "Une erreur est survenue lors du remplacement de cette SIM"
        },
        "multiple_activation": {
            "title": "Activation multiple de mes cartes SIM",
            "provider": {
                "label": "Fournisseur :"
            },
            "offer": {
                "label": "Forfait :"
            },
            "confirmation": {
                "text_1": "Êtes-vous sûr de vouloir activer ces cartes SIM avec le forfait \"{{offer}}\" ?",
                "text_2": "Pour information, le délai généralement constaté est d'environ 2h.",
                "text_3": "Veillez donc à anticiper vos demandes d'activations."
            },
            "partial_activation": {
                "text_1": "L’activation des SIM a été effectuée partiellement à cause de la présence d'erreurs dans la liste. Vous trouverez ci-dessous la liste des numéros de SIM qui n'ont pas pu être ajoutés :",
                "text_2": "Vous pouvez retenter l'opération d'activation multi-SIM. Si l'erreur persiste, veuillez contacter l'équipe support."
            },
            "steps": {
                "provider_selection": "Étape {{step}} sur {{maxStep}} : Sélection du fournisseur des cartes SIM",
                "client_selection": "Étape {{step}} sur {{maxStep}} : Sélection du client",
                "sims_selection": "Étape {{step}} sur {{maxStep}} : Sélection des cartes SIM à activer",
                "offer_selection": "Étape {{step}} sur {{maxStep}} : Sélection du forfait",
                "confirmation": "Étape {{step}} sur {{maxStep}} : Confirmation"
            },
            "success": "Cartes SIM activées avec succès !",
            "error": "Une erreur est survenue lors de l'activation des cartes SIM",
            "error_providers": "Une erreur est survenue lors de la récupération des fournisseurs"
        },
        "order_sim": {
            "title": "Commander des cartes SIM",
            "details": "Détails de la commande",
            "address": "Adresse de livraison",
            "my_address": "Mon adresse",
            "other_address": "Une autre adresse",
            "steps": {
                "details": "Étape {{step}} sur {{maxStep}} : Saisie des détails de la commande",
                "confirmation": "Étape {{step}} sur {{maxStep}} : Confirmation de la commande"
            },
            "form": {
                "provider": "Fournisseur :",
                "provider_placeholder": "Choisir un fournisseur",
                "quantity": "Quantité :",
                "civility": "Civilité :",
                "contact_name": "Nom du contact :",
                "contact_surname": "Prénom du contact :",
                "phone_number": "Numéro de téléphone (ex: 0601020304) :",
                "company": "Nom de la société :",
                "street": "Libellé de voie :",
                "post_code": "Code postal :",
                "city": "Ville :",
                "street_number": "Numéro de voie :",
                "address": "Libellé de voie :",
                "additional_address": "Complément d'adresse :",
                "borough_needed": "Indiquez un arrondissement (ex :"
            },
            "summary": {
                "title": "Résumé de la commande",
                "keys": {
                    "quantity": "Quantité :",
                    "civility": "Civilité :",
                    "contact_name": "Nom du contact :",
                    "contact_surname": "Prénom du contact :",
                    "phone_number": "Numéro de téléphone :",
                    "company": "Nom de la société :",
                    "street": "Libellé de voie :",
                    "post_code": "Code postal :",
                    "city": "Ville :"
                }
            },
            "validation": {
                "text1": "Merci pour votre commande !",
                "text2": "Pour information, les livraisons de SIM peuvent prendre jusqu'à 1 semaine.",
                "text3": "Veillez donc à anticiper vos commandes de SIM."
            },
            "error": "Une erreur est survenue, veuillez contacter notre support technique."
        },
        "add": {
            "title": "Ajouter des cartes SIM",
            "steps": {
                "client_selection": "Étape {{step}} sur {{maxStep}} : Sélection du client",
                "add_sims": "Étape {{step}} sur {{maxStep}} : Ajout des cartes SIM",
                "order": "Étape {{step}} sur {{maxStep}} : Saisie de l'Order ID",
                "confirmation": "Étape {{step}} sur {{maxStep}} : Confirmation"
            },
            "labels": {
                "provider": "Fournisseur :",
                "sims": "Numéros de SIM :",
                "order": "Order ID :"
            },
            "placeholder": {
                "sims": "Entrer les numéros de SIM ici...",
                "order": "Entrer l'Order ID ici..."
            },
            "text": {
                "number": "Total de SIM traitées : {{simNumber}}",
                "exists": "La SIM {{simAlreadyAdded}} a déjà été ajoutée !",
                "invalid": "Le numéro de SIM {{invalidSimNumber}} est invalide !",
                "confirmation": "Les SIM liées à l'Order ID n°{{orderId}} seront ajoutées au portail. Souhaitez vous continuer ?"
            },
            "success": "Cartes SIM ajoutées à l'organisation avec succès !",
            "error": "Une erreur est survenue lors de l'ajout des cartes SIM à l'organisation",
            "error_providers": "Une erreur est survenue lors de la récupération des fournisseurs"
        },
        "assign": {
            "title": "Affecter des cartes SIM",
            "steps": {
                "client_selection": "Étape {{step}} sur {{maxStep}} : Sélection du client",
                "assign_sims": "Étape {{step}} sur {{maxStep}} : Saisie des cartes SIM à affecter"
            },
            "success": "Cartes SIM affectées au client avec succès !",
            "error": "Une erreur est survenue lors de l'affectation des cartes SIM"
        },
        "reassign": {
            "title": "Réaffecter des cartes SIM",
            "steps": {
                "action_selection": "Étape {{step}} sur {{maxStep}} : Type d'entrée",
                "sims_selection": "Étape {{step}} sur {{maxStep}} : Cartes SIM",
                "client_selection": "Étape {{step}} sur {{maxStep}} : Sélection du client",
                "confirmation": "Étape {{step}} sur {{maxStep}} : Confirmation"
            },
            "labels": {
                "action": "Option :"
            },
            "text": {
                "confirmation": "Êtes-vous sûr de vouloir réaffecter ces cartes SIM au client {{clientName}} ?"
            },
            "success": "Cartes SIM réaffectées au client avec succès !",
            "error": "Une erreur est survenue lors de la réaffectation des cartes SIM"
        },
        "unassign": {
            "title": "Désaffecter des cartes SIM",
            "steps": {
                "action_selection": "Étape {{step}} sur {{maxStep}} : Type d'entrée",
                "sims_selection": "Étape {{step}} sur {{maxStep}} : Cartes SIM",
                "confirmation": "Étape {{step}} sur {{maxStep}} : Confirmation"
            },
            "labels": {
                "action": "Choix de la méthode :"
            },
            "text": {
                "confirmation": "Êtes-vous sûr de vouloir désaffecter ces cartes SIM ?"
            },
            "success": "Cartes SIM désaffectées avec succès !",
            "error": "Une erreur est survenue lors de la désaffectation des cartes SIM"
        },
        "custom_pay_multiple_activation": {
            "title": "Activation multi-SIM",
            "steps": {
                "client_selection": "Étape {{step}} sur {{maxStep}} : Sélection du client",
                "sims_selection": "Étape {{step}} sur {{maxStep}} : Sélection des cartes SIM à activer",
                "offer_selection": "Étape {{step}} sur {{maxStep}} : Sélection du forfait",
                "confirmation": "Étape {{step}} sur {{maxStep}} : Confirmation"
            },
            "labels": {
                "offer": "Forfait :"
            },
            "text": {
                "confirmation": "Êtes-vous sûr de vouloir activer {{simNumber}} SIM avec le forfait \"{{offer}}\" ?"
            },
            "success": "Cartes SIM activées avec succès !",
            "error": "Une erreur est survenue lors de l'activation des cartes SIM",
            "error_offers": "Une erreur est survenue lors de la récupération des offres"
        },
        "import": {
            "explanations": {
                "header": "Il est possible de réaliser des opérations par téléversement de fichier. Le fichier est au format CSV et doit contenir les 4 colonnes suivantes :",
                "operation": "La colonne Opérations correspond au type d'opération à effectuer sur la SIM. La valeur possible est \"ACTIVATION\" pour une activation.",
                "iccid": "La colonne ICCID correspond à l'ICCID de la SIM commençant par \"89\" sur laquelle doit avoir lieu l'opération.",
                "contract": "La colonne Contrat correspond au contrat à souscrire pour la SIM lors d'une activation. Les valeurs possibles sont :",
                "client": "La colonne Client permet d'affecter la SIM lors d'une activation. Il correspond au nom de l'organisation, trouvable dans le menu Organisations.",
                "offers": {
                    "ing_2": "Ingenico 2MB",
                    "ing_5": "Ingenico 5MB",
                    "ing_10": "Ingenico 10MB",
                    "ing_50": "Ingenico 50MB",
                    "ing_100": "Ingenico 100MB"
                }
            },
            "confirmation": "Cette opération va activer {{activations}} SIM et résilier {{terminations}} SIM. Souhaitez-vous continuer ?",
            "success": "Opérations effectuées avec succès !",
            "error": {
                "invalid_file": "Ce fichier n'est pas compatible (.csv uniquement)",
                "BAD_REQUEST": "Une erreur inconnue est survenue",
                "OFFER_NOT_FOUND": "Le client spécifié est inconnu",
                "FORBIDDEN": "Le fournisseur n'est pas compatible avec ce client",
                "RESULT_LENGTH_MISMATCH": "Il existe des SIMs inconnues dans le fichier",
                "BAD_FORMAT": "Erreur de format dans le fichier",
                "INTERNAL_SERVER_ERROR": "Une erreur inconnue est survenue"
            }
        }
    },
    "tooltip": {
        "data_usage": "Consommation totale en Mo depuis le 1er du mois courant"
    },
    "next_offer": {
        "pending": "Une demande de modification de l'offre est en cours de traitement chez l'opérateur ({{nextOffer}}).",
        "pending_no_display_name": "Une demande de modification de l'offre est en cours de traitement chez l’opérateur."
    },
    "next_iccid": {
        "pending": "Une demande de remplacement de la carte SIM est en cours de traitement chez l'opérateur ({{simData}}",
        "pending_no_display_name": "Une demande de remplacement de la carte SIM est en cours de traitement chez l’opérateur."
    },
    "select_options": {
        "sim": {
            "select": "Sélection de SIM",
            "input": "Saisie de SIM"
        }
    },
    "sim_pools": {
        "keys": {
            "organization": "Organisation",
            "tariff_data": "Forfait",
            "sim_provider": "Fournisseur",
            "activated_sims": "SIM actives",
            "monthly_consumption": "Conso.mois",
            "total_data": "Données totales",
            "consumption_percentage": "% Consommés"
        },
        "filter": {
            "placeholder": {
                "organization": "Filtrer par nom de l'organisation",
                "provider": "Filtrer par nom de fournisseur"
            }
        },
        "tooltip": {
            "sim_groups_tab": "Liste des groupes de SIMs. Un clic sur le bouton \"Voir les détails\" permet d’afficher les détails d’un groupe de SIMs.",
            "activated_sims": "Nombre de SIM ayant été actives à un moment dans le mois en cours. Cela regroupe les cartes Actives, Suspendues ou Résiliées dans le mois en cours.",
            "monthly_consumption": "Consommation totale depuis le 1er du mois courant par l’ensemble des SIM ayant le forfait indiqué dans la colonne forfait pour l’organisation indiquée dans la colonne organisation.",
            "total_data": "Somme des forfaits des cartes SIM ayant le forfait indiqué dans la colonne Forfait pour l’organisation indiquée dans la colonne organisation. La somme comporte les forfaits de toutes les cartes ayant été actives à un moment dans le mois en cours."
        }
    },
    "status": {
        "UNKNOWN": "Inconnu",
        "INACTIVE": "Inactive",
        "PENDING_ACTIVATION": "En cours d'activation",
        "PREACTIVATED": "Préactivée",
        "ACTIVATED": "Activée",
        "PENDING_SUSPENSION": "En cours de suspension",
        "SUSPENDED": "Suspendue",
        "PENDING_TERMINATION": "En cours de résiliation",
        "TERMINATED": "Résiliée",
        "PENDING_REPLACE": "En cours de remplacement"
    },
    "units": {
        "MB": "Mo",
        "GB": "Go",
        "MO": "Mo",
        "GO": "Go"
    }
}